'use client';

import { create } from 'zustand';

const STORAGE_KEY = 'scope-selection';

function readSelection(): string[] {
	if (typeof window === 'undefined') return [];
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		const parsed = raw ? (JSON.parse(raw) as unknown) : null;
		return Array.isArray(parsed) ? (parsed.filter((x) => typeof x === 'string') as string[]) : [];
	} catch {
		return [];
	}
}

function writeSelection(ids: string[]) {
	if (typeof window === 'undefined') return;
	localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

interface ScopeStore {
	/** Selected configuration (leaf org) ids — the source of truth for the stats scope. */
	selectedOrgIds: string[];
	setSelection: (ids: string[]) => void;
	clear: () => void;
}

export const useScopeStore = create<ScopeStore>((set) => ({
	selectedOrgIds: readSelection(),
	setSelection: (ids) => {
		writeSelection(ids);
		set({ selectedOrgIds: ids });
	},
	clear: () => {
		writeSelection([]);
		set({ selectedOrgIds: [] });
	},
}));
